module.exports = __webpack_public_path__ + "img/dsci0053.3878f134.jpg";